'use client';
import { useState, useRef } from 'react';
import { FaWhatsapp } from "react-icons/fa";

const destinationPackages = {
  vietnam: {
    title: "Vietnam ",
    packages: [
      // {
      //   id: 1,
      //   title: "Phu Quoc | Without Flight ",
      //   duration: "4 Days & 3 Nights",
      //   originalPrice: "₹25,000*",
      //   pageUrl: "/#",
      //   whatsappMessage: "Hi! I'm interested in the Phu Quoc 4D/3N (Without Flight) package. Can you provide more details?",
      //   imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/08/Grand-World-Phu-Quoc-scaled.webp"
      // },
      {
        id: 2,
        title: "Phu Quoc | Without Flight ",
        duration: "4 Nights & 5 Days ",
        originalPrice: "₹31,999*",
        pageUrl: "/vietnam-danang-cultural-package",
        whatsappMessage: "Hi! I'm interested in the Phu Quoc 5D/4N (Without Flight) package. Can you provide more details?",
        imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/08/couple-taking-bus-tour-feeding-playing-with-giraffe-safari-open-park-zoo-scaled.webp"
      },
      // {
      //   id: 3,
      //   title: "Hanoi | Without Flight ",
      //   duration: "4 Days & 3 Nights",
      //   originalPrice: "₹30,000*",
      //   pageUrl: "/vietnam-hanoi-heritage-package",
      //   whatsappMessage: "Hi! I'm interested in the Hanoi 4D/3N (Without Flight) package. Can you provide more details?",
      //   imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/Hanoi-Package-scaled.webp"
      // },
      // {
      //   id: 4,
      //   title: "Da Nang | Without Flight ",
      //   duration: "4 Days & 3 Nights",
      //   originalPrice: "₹39,999*",
      //   pageUrl: "/vietnam-hanoi-heritage-package",
      //   whatsappMessage: "Hi! I'm interested in the Da Nang 4D/3N (Without Flight) package. Can you provide more details?",
      //   imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/Da-Nang-Package-1-scaled.webp"
      // },
      {
        id: 5,
        title: "Vietnam Package | With Flight ",
        duration: "5 Nights & 6 Days",
        originalPrice: "₹1,25,000*",
        pageUrl: "/vietnam-hanoi-heritage-package",
        whatsappMessage: "Hi! I'm interested in the Vietnam 5N/6D package. Can you provide more details?",
        imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/banner-1-scaled.webp"
      },
      {
        id: 6,
        title: "Vietnam & Cambodia | With Flight ",
        duration: "7 Nights & 8 Days",
        originalPrice: "₹1,70,000*",
        pageUrl: "/vietnam-hanoi-heritage-package",
        whatsappMessage: "Hi! I'm interested in the Vietnam & Cambodia 7N/8D package. Can you provide more details?",
        imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/Vietnam-Cambodia-scaled.webp"
      }
    ]
  },
  singapore: {
    title: "Singapore & Malaysia ",
    packages: [
      // {
      //   id: 7,
      //   title: "Singapore | Without Flight",
      //   duration: "4 Days & 3 Nights",
      //   originalPrice: "₹44,455*",
      //   pageUrl: "/singapore-city-escape-package",
      //   whatsappMessage: "Hi! I'm interested in the Singapore 4D/3N (Without Flight) package. Can you provide more details?",
      //   imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/Singapore-banner-1-scaled.jpg"
      // },
      // {
      //   id: 8,
      //   title: "Singapore | With Flight",
      //   duration: "4 Days & 3 Nights",
      //   originalPrice: "₹64,455*",
      //   pageUrl: "/singapore-family-fun-package",
      //   whatsappMessage: "Hi! I'm interested in the Singapore 4D/3N package. Can you provide more details?",
      //   imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/Singapore-banner-6-scaled.jpg"
      // },
      // {
      //   id: 9,
      //   title: "Singapore & Kuala Lumpur | Without Flight",
      //   duration: "6 Days & 5 Nights",
      //   originalPrice: "₹85,000*",
      //   pageUrl: "/singapore-family-fun-package",
      //   whatsappMessage: "Hi! I'm interested in the Singapore & Kuala Lumpur 6D/5N (Without Flight) package. Can you provide more details?",
      //   imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/Singapore-banner-3-scaled.jpg"
      // },
      {
        id: 10,
        title: "Singapore & Malaysia | With Flight",
        duration: "6 Nights & 7 Days",
        originalPrice: "₹1,25,000*",
        pageUrl: "/singapore-family-fun-package",
        whatsappMessage: "Hi! I'm interested in the Singapore & Malaysia 6N/7D package. Can you provide more details?",
        imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/malasiya-muruga-scaled.jpg"
      }
    ]
  },
  dubai: {
    title: "Dubai ",
    packages: [
      // {
      //   id: 11,
      //   title: "Dubai | Without Flight",
      //   duration: "4 Days & 3 Nights",
      //   originalPrice: "₹34,999*",
      //   pageUrl: "/dubai-luxury-escape-package",
      //   whatsappMessage: "Hi! I'm interested in the Dubai 4D/3N (Without Flight) package. Can you provide more details?",
      //   imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/futuristic-dubai-landscape-scaled.webp"
      // },
      // {
      //   id: 12,
      //   title: "Dubai | Without Flight",
      //   duration: "5 Days & 4 Nights",
      //   originalPrice: "₹44,999*",
      //   pageUrl: "/dubai-family-adventure-package",
      //   whatsappMessage: "Hi! I'm interested in the Dubai 5D/4N (Without Flight) package. Can you provide more details?",
      //   imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/ferrari-world-abu-dhabi-scaled.webp"
      // },
      {
        id: 13,
        title: "Dubai | With Flight",
        duration: "5 Nights & 6 Days",
        originalPrice: "₹1,24,999*",
        pageUrl: "/dubai-family-adventure-package",
        whatsappMessage: "Hi! I'm interested in the Dubai 5N/6D package. Can you provide more details?",
        imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/dubai-uae-november-04-2021-view-burj-al-arab-hotel-from-madinat-jumeirah-dubai-sunset-luxury-modern-architecture-tourism-concept-scaled.webp"
      },
    ]
  },
  bali: {
    title: "Bali ",
    packages: [
      // {
      //   id: 14,
      //   title: "Bali | Without Flight",
      //   duration: "5 Days & 4 Nights",
      //   originalPrice: "₹25,000*",
      //   pageUrl: "/bali-cultural-immersion-package",
      //   whatsappMessage: "Hi! I'm interested in the Bali 5D/4N (Without Flight) package. Can you provide more details?",
      //   imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/rear-view-woman-standing-against-historic-structure-scaled.webp"
      // },
      {
        id: 15,
        title: "Bali | With Flight",
        duration: "5 Nights & 6 Days",
        originalPrice: "₹99,999*",
        pageUrl: "/bali-cultural-immersion-package",
        whatsappMessage: "Hi! I'm interested in the Bali 5N/6D package. Can you provide more details?",
        imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/pura-ulun-danu-bratan-hindu-temple-surrounded-by-flowers-bratan-lake-bali-scaled.webp"
      }
    ]
  },
  srilanka: {
    title: "Sri Lanka ",
    packages: [
      // {
      //   id: 16,
      //   title: "Sri Lanka | Without Flight",
      //   duration: "4 Days & 3 Nights",
      //   originalPrice: "₹29,000*",
      //   pageUrl: "/srilanka-highlights-package",
      //   whatsappMessage: "Hi! I'm interested in the Sri Lanka 4D/3N (Without Flight) package. Can you provide more details?",
      //   imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/08/aerial-view-colombo-city-sunny-day-scaled.webp"
      // },
      // {
      //   id: 17,
      //   title: "Sri Lanka | Without Flight",
      //   duration: "5 Days & 4 Nights",
      //   originalPrice: "₹39,000*",
      //   pageUrl: "/srilanka-highlights-package",
      //   whatsappMessage: "Hi! I'm interested in the Sri Lanka 5D/4N (Without Flight) package. Can you provide more details?",
      //   imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/08/shallow-focus-shot-mother-baby-elephant-walking-grass-field-daytime-scaled.webp"
      // },
      {
        id: 18,
        title: "Sri Lanka | With Flight",
        duration: "5 Nights & 6 Days",
        originalPrice: "₹75,000*",
        pageUrl: "/srilanka-highlights-package",
        whatsappMessage: "Hi! I'm interested in the Sri Lanka 5N/6D (With Flight) package. Can you provide more details?",
        imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/08/train-passing-through-forest-scaled.webp"
      },
      // {
      //   id: 19,
      //   title: "Sri Lanka | With Flight",
      //   duration: "7 Days & 6 Nights",
      //   originalPrice: "₹85,000*",
      //   pageUrl: "/srilanka-highlights-package",
      //   whatsappMessage: "Hi! I'm interested in the Sri Lanka 7D/6N package. Can you provide more details?",
      //   imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/08/famous-nine-arch-bridge-railway-jungle-sri-lanka-scaled.webp"
      // },

    ]
  },
  nepal: {
    title: "Nepal",
    packages: [
      {
        id: 20,
        title: "Nepal | With Flight",
        duration: "7 Nights & 8 Days",
        originalPrice: "₹75,000*",
        pageUrl: "/nepal-everest-trek-package",
        whatsappMessage: "Hi! I'm interested in the Nepal 7N/8D package. Can you provide more details?",
        imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/07/unesco-world-heritage-site-swayambhunath-monkey-temple-buddhists-hindus-kathmandu-nepal-scaled.jpg"
      }
    ]
  },
  bhutan: {
    title: "Bhutan",
    packages: [
      {
        id: 21,
        title: "Bhutan | With Flight",
        duration: "6 Nights & 7 Days",
        originalPrice: "₹68,999*",
        pageUrl: "/bhutan-mystical-kingdom-package",
        whatsappMessage: "Hi! I'm interested in the Bhutan 6N/7D package. Can you provide more details?",
        imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2025/08/low-angle-view-building-against-trees-1-scaled.webp"
      }
    ]
  },
  Japan: {
    title: "Japan",
    packages: [
      {
        id: 21,
        title: "Japan | With Flight",
        duration: "7 Nights & 8 Days",
        originalPrice: "₹3,40,000*",
        pageUrl: "/bhutan-mystical-kingdom-package",
        whatsappMessage: "Hi! I'm interested in the Japan package. Can you provide more details?",
        imageUrl: "https://trip.saishishirtours.in/wp-content/uploads/2026/01/asian-woman-wearing-japanese-traditional-kimono-yasaka-pagoda-sannen-zaka-street-kyoto-japan-scaled.webp"
      }
    ]
  }
};

// ✅ Reuse the same constants
const TELECRM_API_URL =
  "https://next-api.telecrm.in/enterprise/66ec0997759f100018f5cbfe/autoupdatelead";
const TELECRM_BEARER_TOKEN =
  "03d8ea9a-3d6a-4067-a35b-26f0c11f52a31755503300325:981a1bd8-8510-4456-98db-c96c6977f61c";
const MAKE_WEBHOOK_URL =
  "https://hook.eu2.make.com/ci8kvviwxqmkhtwduooilcxlrm51fcuf";
const WEB3FORMS_ACCESS_KEY =
  "1af8dd38-c767-42f7-82c2-f76edac26a9f";

const PackageForm = ({ selectedPackage, setShowPopup }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  // ✅ TeleCRM integration
  const sendToTeleCRM = async (values) => {
    try {
      const fields = {
        name: values.fullName,
        phone: values.phoneNumber,
        email: values.email,
        INTL: values.packageTitle || "",
        package: "International",
        message: values.packageDetails || "",
        leadSource: "INT Google Ad",
      };

      const actions = [
        {
          type: "SYSTEM_NOTE",
          text: `Lead from Website
Package: ${values.packageTitle}
Duration: ${values.duration}
Price: ${values.price}
ID: ${values.packageId}
Email: ${values.email}
Phone: ${values.phoneNumber}
Page URL: ${values.pageUrl}
Submitted At: ${values.submissionTime}`,
        },
      ];

      const payload = { fields, actions };

      const res = await fetch(TELECRM_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TELECRM_BEARER_TOKEN}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error(`TeleCRM failed: ${res.status}`);
      console.log("✅ TeleCRM submission success");
      return true;
    } catch (err) {
      console.error("❌ TeleCRM error:", err);
      return false;
    }
  };

  // ✅ Make.com webhook integration
  const sendToMakeWebhook = async (data) => {
    try {
      const payload = {
        formData: data,
        timestamp: new Date().toISOString(),
        source: "Package Enquiry Form",
      };

      const res = await fetch(MAKE_WEBHOOK_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error(`Make.com failed: ${res.status}`);
      console.log("✅ Make.com webhook success");
      return true;
    } catch (err) {
      console.error("❌ Make.com error:", err);
      return false;
    }
  };

  // ✅ Web3Forms email integration
  const sendToWeb3Forms = async (data) => {
    try {
      const payload = {
        access_key: WEB3FORMS_ACCESS_KEY,
        name: data.fullName,
        email: data.email,
        phone: data.phoneNumber,
        subject: `New Enquiry for ${data.packageTitle}`,
        message: `
New Package Enquiry:

Name: ${data.fullName}
Phone: ${data.phoneNumber}
Email: ${data.email}

Package: ${data.packageTitle}
Duration: ${data.duration}
Price: ${data.price}
ID: ${data.packageId}

Page URL: ${data.pageUrl}
Submitted At: ${data.submissionTime}
        `,
          from_name: "Google Ads International Leads",
      };

      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error(`Web3Forms failed: ${res.status}`);
      console.log("✅ Web3Forms email success");
      return true;
    } catch (err) {
      console.error("❌ Web3Forms error:", err);
      return false;
    }
  };

  // ✅ Handle Form Submit
const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  const formData = new FormData(e.target);
  
  // Get the phone number from input and prepend +91
  const phoneInput = formData.get("phoneNumber");
  const fullPhoneNumber = `+91${phoneInput}`;
  
  const values = {
    fullName: formData.get("fullName"),
    phoneNumber: fullPhoneNumber, // Use the formatted number
    email: formData.get("email"),
    packageDetails: formData.get("packageDetails"),
    packageTitle: selectedPackage.title,
    duration: selectedPackage.duration,
    price: selectedPackage.originalPrice,
    packageId: selectedPackage.id,
    pageUrl: window.location.href,
    submissionTime: new Date().toISOString(),
  };

    const promises = [
      sendToTeleCRM(values),
      sendToMakeWebhook(values),
      sendToWeb3Forms(values),
    ];

    const results = await Promise.all(promises);
    const successCount = results.filter((r) => r === true).length;

   if (successCount > 0) {
  // Redirect to thank you page
  window.location.href = "https://mytrip.saishishirtours.in/thank-you";
  setShowPopup(false);
} else {
  alert("❌ Submission failed. Please try again.");
}

    setIsSubmitting(false);
  };

  return (
    <form onSubmit={handleFormSubmit}>
      {/* Hidden message field with all package details */}
      <input
        type="hidden"
        name="packageDetails"
        value={`Package: ${selectedPackage.title}, Duration: ${selectedPackage.duration}, Price: ${selectedPackage.originalPrice}, ID: ${selectedPackage.id}`}
      />

      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label fw-semibold">Full Name *</label>
          <input
            type="text"
            name="fullName"
              placeholder="Full Name"
            className="form-control"
            required
            style={{ borderRadius: "8px" }}
          />
        </div>
       <div className="col-md-6">
  <label className="form-label fw-semibold">Phone Number *</label>
  <div className="input-group">
    <span 
      className="input-group-text" 
      style={{ 
        borderRadius: "8px 0 0 8px",
        backgroundColor: "#f8f9fa",
        border: "1px solid #ced4da",
        borderRight: "none"
      }}
    >
      +91
    </span>
    <input
      type="tel"
      name="phoneNumber"
      className="form-control"
      required
      placeholder="Phone No"
      style={{ 
        borderRadius: "0 8px 8px 0",
        borderLeft: "none"
      }}
      onInput={(e) => {
        // Allow only numbers
        e.target.value = e.target.value.replace(/\D/g, '');
        // Limit to 10 digits
        if (e.target.value.length > 10) {
          e.target.value = e.target.value.slice(0, 10);
        }
      }}
    />
  </div>
</div>
        <div className="col-12">
          <label className="form-label fw-semibold">Email Address *</label>
          <input
            type="email"
            name="email"
              placeholder="Email Address ( Optinal )"
            className="form-control"
            required
            style={{ borderRadius: "8px" }}
          />
        </div>
      </div>

      <div className="d-flex gap-3 mt-4">
        {/* <button
          type="button"
          className="btn btn-outline-secondary flex-grow-1"
          onClick={() => setShowPopup(false)}
          style={{ borderRadius: "8px" }}
        >
          Cancel
        </button> */}
        <button
          type="submit"
          disabled={isSubmitting}
          className="btn flex-grow-1 fw-semibold"
          style={{
            backgroundColor: "#ff9f26",
            color: "#0b4878",
            border: "none",
            borderRadius: "8px",
          }}
        >
          {isSubmitting ? "Submitting..." : "Submit Enquiry"}
        </button>
      </div>
    </form>
  );
};

const DestinationPackages = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const sectionRefs = useRef({});
  const destinations = Object.keys(destinationPackages);

  const scrollToSection = (destination) => {
    const element = sectionRefs.current[destination];
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const handleWhatsAppClick = (message) => {
    const phoneNumber = "918951062993"; // Replace with your WhatsApp number
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleEnquireNow = (pkg) => {
    setSelectedPackage(pkg);
    setShowPopup(true);
  };

  // const handleCardClick = (pageUrl) => {
  //   window.location.href = pageUrl;
  // };

  const PackageCard = ({ pkg }) => (
    <div className="col-lg-4 col-md-6 col-12 mb-4">
      <div 
        className="card h-100 border-0 shadow-sm position-relative"
        style={{ 
          borderRadius: '16px', 
          overflow: 'hidden',
          cursor: 'pointer',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-8px)';
          e.currentTarget.style.boxShadow = '0 12px 30px rgba(11, 72, 120, 0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
        }}
        
      >
        <div className="position-relative">
          <div 
            className="card-img-top d-flex align-items-end justify-content-start p-4"
            style={{
              height: '250px',
              background: `linear-gradient(0deg, rgba(11, 72, 120, 0), rgba(11, 72, 120, 0.3)), url(${pkg.imageUrl}) center/cover`,
              color: 'white'
            }}
          >
          </div>
          
          <div className="position-absolute top-0 end-0 m-3">
            <span className="badge px-3 py-2" style={{ 
              backgroundColor: 'rgba(255, 255, 255, 0.9)', 
              color: '#0b4878',
              borderRadius: '20px',
              fontSize: '0.75rem',
              fontWeight: '600'
            }}>
              {pkg.duration}
            </span>
          </div>
        </div>
        
        <div className="card-body p-4">
          <div className="mb-4">
            <div>
              <h5 className="fw-bold mb-1" style={{ fontSize: '1.1rem',color: '#0b4878', }}>
                {pkg.title.split('|')[0].trim()}
              </h5>
              <p className="mb-0 opacity-75" style={{ fontSize: '0.85rem',color: '#0b4878', }}>
                {pkg.title.split('|')[1]?.trim()}
              </p>
            </div>
            <div className="fw-bold mb-1" style={{ color: '#0b4878', fontSize: '1.25rem' }}>
              Starting from {pkg.originalPrice}
            </div>
            {/* <p className="text-muted small mb-0">*Per person on twin sharing</p> */}
          </div>
          
          <div className="d-flex gap-2" onClick={(e) => e.stopPropagation()}>
            <button 
              className="btn btn-sm d-flex align-items-center justify-content-center"
              style={{ 
                width: '45px',
                height: '38px',
                backgroundColor:'#37c968',
                borderRadius: '8px',
                fontSize: '1.1rem'
              }}
              onClick={() => handleWhatsAppClick(pkg.whatsappMessage)}
              title="WhatsApp"
            >
             <FaWhatsapp size={18} color="white" />
            </button>
            <button 
              className="btn flex-grow-1 btn-sm fw-semibold py-2"
              style={{ 
                backgroundColor: '#ff9f26', 
                color: '#0b4878', 
                border: 'none',
                borderRadius: '8px',
                fontSize: '0.9rem'
              }}
              onClick={() => handleEnquireNow(pkg)}
            >
              Enquire Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="container-fluid py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container">
          {/* Header */}
          <div className="text-center mb-5">
            <h2 className="fw-bold mb-3" style={{ color: '#0b4878', fontSize: '2.5rem' }}>
              Explore Amazing Destinations
            </h2>
            <p className="text-muted fs-5 mb-4">
              Handcrafted travel experiences for your perfect getaway
            </p>
            
            {/* Destination Navigation */}
            <div className="d-flex flex-wrap justify-content-center gap-3">
              {destinations.map((dest) => (
                <button
                  key={dest}
                  className="btn px-4 py-2 fw-semibold"
                  style={{
                    backgroundColor: '#fff',
                    color: '#0b4878',
                    border: '2px solid #0b4878',
                    borderRadius: '30px',
                    fontSize: '0.9rem',
                    textTransform: 'capitalize',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#0b4878';
                    e.target.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#fff';
                    e.target.style.color = '#0b4878';
                  }}
                  onClick={() => scrollToSection(dest)}
                >
                  {destinationPackages[dest].title}
                </button>
              ))}
            </div>
          </div>

          {/* All Packages Sections */}
          {destinations.map((dest) => (
            <div 
              key={dest}
              ref={el => sectionRefs.current[dest] = el}
              className="mb-5"
            >
              <div className="d-flex align-items-center mb-4">
                
                <h3 className="fw-bold mb-0" style={{ color: '#0b4878', fontSize: '1.8rem' }}>
                  {destinationPackages[dest].title} Tour Packages
                </h3>
              </div>
              
              <div className="row">
                {destinationPackages[dest].packages.map((pkg) => (
                  <PackageCard key={pkg.id} pkg={pkg} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Enquiry Popup Modal */}
      {showPopup && selectedPackage && (
        <div 
          className="modal show d-block"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1050 }}
          onClick={() => setShowPopup(false)}
        >
          <div 
            className="modal-dialog p-2 modal-dialog-centered"
            style={{ maxWidth: '450px' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content" style={{ borderRadius: '16px' }}>
              <div className="modal-header border-0 pb-0">
                <h5 className="modal-title fw-bold" style={{ color: '#0b4878' }}>
                  Enquire About Package
                </h5>
                <button 
                  type="button" 
                  className="btn-close"
                  onClick={() => setShowPopup(false)}
                ></button>
              </div>
              
              <div className="modal-body">
                <div className="p-3 mb-4" style={{ 
                  backgroundColor: '#f8f9fa', 
                  borderRadius: '12px',
                  border: '2px solid #ff9f26'
                }}>
                  <h6 className="fw-bold mb-2" style={{ color: '#0b4878' }}>
                    {selectedPackage.title}
                  </h6>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="badge" style={{ 
                      backgroundColor: '#ff9f26', 
                      color: '#0b4878',
                      fontSize: '0.8rem'
                    }}>
                      {selectedPackage.duration}
                    </span>
                    <span className="fw-bold" style={{ color: '#0b4878' }}>
                      {selectedPackage.originalPrice}
                    </span>
                  </div>
                </div>

                <PackageForm selectedPackage={selectedPackage} setShowPopup={setShowPopup} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DestinationPackages;